module.exports = __webpack_public_path__ + "static/media/mercadopago.63a71fc4.svg";